/**
 * Get the EMIT checksum digit for a 6-digit number.
 * @param number
 * @returns
 * @throws If the number is not a 6-digit integer
 */
export function EMITGetChecksum(number: number): number {
    if (number < 100000 || number > 999999) {
        throw new Error('Number must be a 6-digit integer.');
    }

    let aDigit: number,
        aTotal = 0,
        aWeight = 2;
    do {
        aDigit = number % 10;
        aDigit = aWeight * aDigit;
        aTotal += Math.floor(aDigit / 10) + (aDigit % 10);
        number = Math.floor(number / 10);
        aWeight = 3 - aWeight;
    } while (number !== 0);

    return (10 - (aTotal % 10)) % 10;
}

/**
 * Check if a participant ID is a valid EMIT ID.
 * @param participantID
 * @returns
 */
export function EMITIsValid(participantID: number): boolean {
    try {
        const checksumDigit = participantID % 10;
        const numberWithoutChecksum = Math.floor(participantID / 10);
        const calculatedChecksum = EMITGetChecksum(numberWithoutChecksum);

        return checksumDigit === calculatedChecksum;
    } catch {
        return false;
    }
}
